import { Request, getRequestUrl } from "../../request";
import { getURL } from "../../utils";

export const get_cars = (data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        code: 200,
        success: true,
        message: "",
        pagination: {
          count: 4,
          pages: 1,
          page: 1,
          limit: 10,
          next: null,
          next_url: null,
          previous: null,
          previous_url: null,
        },
        data: [
          {
            id: 6,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1385",
            plate_number: "74ع58543",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 5,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1385",
            plate_number: "74ع44243",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1385",
            plate_number: "74ع57743",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 3,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NKR",
              is_jalali: false,
            },
            year: "1395",
            plate_number: "73ع55955",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1395",
            plate_number: "73ع54155",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1393",
            plate_number: "56ع99244",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "ایسوزو",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "NPR",
              is_jalali: false,
            },
            year: "1396",
            plate_number: "75و19222",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "99م71522",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "91م38522",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "91م38522",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
          {
            id: 4,
            is_active: true,
            car: {
              id: 1804,
              brand: "نیسان",
              brand_id: 323,
              name: "ماز 1844",
              type: "heavy",
              model: "زامیاد",
              is_jalali: false,
            },
            year: "1389",
            plate_number: "91م38522",
            city: { name: "اصفهان", id: 8 },
            province: { name: "اصفهان", id: 8 },
          },
        ],
        extra: {},
        meta: {
          site: "helix",
          site_id: 4,
          version: "1.3.8\n",
          app_version: "0.0.0",
        },
      });
    }, 2000);
  });
};

export const get_cars_brands = (type) => {
  return Request.get(getURL("/api/corporation-pa/load_cars_brand/"), {
    type,
  });
};

export const get_cars_models = (brand_id) => {
  return Request.get(getURL("/api/corporation-pa/load_cars/"), {
    brand_id,
  });
};

export const add_car = (data) => {
  return Request.post(getURL(`/api/corporation-pa/cars/company-cars/`), data);
};

export const edit_car = (data) => {
  return Request.put(getURL(`/api/corporation-pa/cars/company-cars/`), data);
};

export const export_cars_report = (data) => {
  return Request.rawGet(getRequestUrl(getURL(`/api/corporation-pa/cars/company-cars/`), data))
}